import { Skeleton } from 'antd';
import React from 'react';

const CardSkeleton = ({ cols = 1 }) => {
  return Array(cols).fill().map((col, index) => (
    <div key={index} className="max-w-sm sm:w-96 h-52 mx-auto md:mx-0">
      <Skeleton.Input
        active
        className="w-full h-full"
        style={{ height: 208 }}
      />
    </div>
  ));
};

export default CardSkeleton;
